export default "__VITE_ASSET__841fe605__"